import React, { useCallback } from "react";
import {
  Typography,
  Box,
  useMediaQuery,
} from "@mui/material";
import WelcomeComponent from "../../WelcomeComponent";
import { useAppSelector, useAppDispatch } from "../../../hooks/hooks";
import { SplashScreen } from "../../SplashScreen";

// Get width from environment variable with fallback
const MOBILE_APP_WIDTH = parseInt(
  process.env.REACT_APP_MOBILE_APP_WIDTH || "500"
);



const HomeView: React.FC = () => {
  const isMobileView = useMediaQuery(`(max-width:${MOBILE_APP_WIDTH}px)`);
  const { isCompletingLogin } = useAppSelector((state) => state.ui);





  // const parsedKycLink = useMemo(() => {
  //   if (!kycLink) return null;

  //   return {
  //     ...kycLink,
  //     // Only parse dates when you need to use them as Date objects
  //     _expiresAt: parseDateSafe(kycLink.expiresAt),
  //     _createdAt: parseDateSafe(kycLink.createdAt),
  //     _updatedAt: parseDateSafe(kycLink.updatedAt),
  //   };
  // }, [kycLink]);

  // Determine KYC status based on kycLink
  // useEffect(() => {
  //   if (isLoadingKycLink) {
  //     setKycStatus("loading");
  //     return;
  //   }

  //   if (!kycLink) {
  //     setKycStatus("not_started");
  //     return;
  //   }

  //   if (
  //     kycLink.status === "not_started" ||
  //     kycLink.status === "pending" ||
  //     kycLink.status === "awaiting.applicant"
  //   ) {
  //     setKycStatus("in-progress");
  //   } else if (
  //     kycLink.status === "completed" ||
  //     kycLink.status === "approved"
  //   ) {
  //     setKycStatus("completed");
  //   } else {
  //     setKycStatus("pending");
  //   }
  // }, [kycLink, isLoadingKycLink]);

  // Fetch KYC link only once when needed


  

  const renderContent = useCallback(() => {
   

    // Default: show welcome component
    return <WelcomeComponent />;
  }, []);

  const getHeaderTitle = useCallback(() => {
    
    return "Welcome";
  }, []);

  // Poll for KYC completion when user might have completed it in another tab
  // 

  return (
    <Box
      sx={{
        p: 2,
        width: "100%",
        maxWidth: MOBILE_APP_WIDTH,
        margin: "auto",
        // Mobile-specific styles
        ...(isMobileView && {
          maxWidth: "100%",
          px: 1,
        }),
        // Desktop-specific styles
        ...(!isMobileView && {
          boxShadow: 1,
          borderRadius: 2,
        }),
      }}
    >
      {!isCompletingLogin && (
        <>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "1.5rem", sm: "2rem" },
              mb: 2,
              textAlign: "left",
            }}
          >
            {getHeaderTitle()}
          </Typography>
          {renderContent()}
        </>
      )}
      {isCompletingLogin && <SplashScreen />}
    </Box>
  );
};

export default HomeView;
